import React, { Suspense } from 'react';
import { Outlet, RouteObject } from 'react-router-dom';
import Skeleton from 'react-loading-skeleton';

const AiHubEndpointPage = React.lazy(() => import('./AiHubEndpointPage'));

export const aiHubEndpointRouter: RouteObject = {
  path: 'dev/ai-hub-endpoint',
  element: (
    <Suspense
      fallback={
        <div className="tw-h-full tw-p-4">
          <Skeleton width="100%" height="100%" />
        </div>
      }
    >
      <Outlet />
    </Suspense>
  ),
  children: [{ index: true, element: <AiHubEndpointPage /> }],
};
